(function () {
  "use strict";

  function initReveals() {
    var els = document.querySelectorAll(".mt-reveal");
    if (!els.length) return;
    var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) {
      els.forEach(function (el) { el.classList.add("mt-visible"); });
      return;
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var delay = entry.target.getAttribute("data-mt-delay") || 0;
            setTimeout(function () {
              entry.target.classList.add("mt-visible");
            }, Number(delay));
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
    );
    els.forEach(function (el) { obs.observe(el); });
  }

  function initContadores() {
    var els = document.querySelectorAll("[data-mt-contador]");
    if (!els.length) return;
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var fin = parseFloat(el.getAttribute("data-mt-contador")) || 0;
          var dur = 1400;
          var t0 = null;
          function paso(ts) {
            if (!t0) t0 = ts;
            var p = Math.min((ts - t0) / dur, 1);
            var ease = 1 - Math.pow(1 - p, 3);
            el.textContent = Math.round(fin * ease).toLocaleString("es-AR");
            if (p < 1) requestAnimationFrame(paso);
            else el.textContent = fin.toLocaleString("es-AR");
          }
          requestAnimationFrame(paso);
          obs.unobserve(el);
        });
      },
      { threshold: 0.4 }
    );
    els.forEach(function (el) { obs.observe(el); });
  }

  function initGaleriaProducto() {
    document.querySelectorAll("[data-mt-galeria]").forEach(function (galeria) {
      var principal = galeria.querySelector("[data-mt-galeria-principal] img");
      var minis = galeria.querySelectorAll("[data-mt-galeria-mini]");
      if (!principal || !minis.length) return;
      minis.forEach(function (mini) {
        mini.addEventListener("click", function () {
          var src = mini.getAttribute("data-mt-src");
          var alt = mini.getAttribute("data-mt-alt") || "";
          if (!src) return;
          principal.setAttribute("src", src);
          principal.setAttribute("alt", alt);
          minis.forEach(function (m) { m.classList.remove("mt-activa"); });
          mini.classList.add("mt-activa");
        });
      });
    });
  }

  function initVariantes() {
    document.querySelectorAll("[data-mt-producto-form]").forEach(function (wrap) {
      var dataEl = wrap.querySelector("[data-mt-variantes-json]");
      if (!dataEl) return;
      var variantes;
      try {
        variantes = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      var idInput = wrap.querySelector('input[name="id"]');
      var botonAgregar = wrap.querySelector("[data-mt-agregar]");
      var precioActual = wrap.querySelector("[data-mt-precio-actual]");
      var precioAnterior = wrap.querySelector("[data-mt-precio-anterior]");
      var estadoTexto = wrap.querySelector("[data-mt-estado]");
      var selects = wrap.querySelectorAll("[data-mt-opcion]");

      function moneda(centavos) {
        return "$" + (centavos / 100).toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }

      function opcionesElegidas() {
        var vals = [];
        selects.forEach(function (grupo) {
          var activo = grupo.querySelector(".mt-seleccionada");
          vals.push(activo ? activo.getAttribute("data-mt-valor") : null);
        });
        return vals;
      }

      function actualizar() {
        var elegidas = opcionesElegidas();
        var match = variantes.find(function (v) {
          return v.options.every(function (o, i) { return o === elegidas[i]; });
        });
        if (!match) return;
        if (idInput) idInput.value = match.id;
        if (precioActual) precioActual.textContent = moneda(match.price);
        if (precioAnterior) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            precioAnterior.textContent = moneda(match.compare_at_price);
            precioAnterior.style.display = "";
          } else {
            precioAnterior.style.display = "none";
          }
        }
        if (botonAgregar) {
          botonAgregar.disabled = !match.available;
          botonAgregar.textContent = match.available
            ? botonAgregar.getAttribute("data-mt-texto-disponible")
            : botonAgregar.getAttribute("data-mt-texto-agotado");
        }
        if (estadoTexto) {
          estadoTexto.textContent = match.available ? "" : "Sin stock por ahora";
        }
        selects.forEach(function (grupo, i) {
          grupo.querySelectorAll("[data-mt-valor]").forEach(function (boton) {
            var prueba = elegidas.slice();
            prueba[i] = boton.getAttribute("data-mt-valor");
            var existe = variantes.some(function (v) {
              return v.options.every(function (o, j) { return o === prueba[j]; });
            });
            boton.disabled = !existe;
          });
        });
      }

      selects.forEach(function (grupo) {
        grupo.querySelectorAll("[data-mt-valor]").forEach(function (boton) {
          boton.addEventListener("click", function () {
            if (boton.disabled) return;
            grupo.querySelectorAll("[data-mt-valor]").forEach(function (b) { b.classList.remove("mt-seleccionada"); });
            boton.classList.add("mt-seleccionada");
            actualizar();
          });
        });
      });

      actualizar();
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initReveals();
    initContadores();
    initGaleriaProducto();
    initVariantes();
  });
})();
